<template>
  <v-list-tile>
    <v-dialog v-model="mostrarDialogoSuspender" persistent max-width="500">
      <v-list-tile-title slot="activator">
        Suspender
      </v-list-tile-title>

      <v-card>
        <v-card-title class="primary modal-title" primary-title>
          Suspender Licitação
        </v-card-title>
        <v-card-text class="pb-0 az-form-content">
          <v-textarea v-model="motivoSuspensao"
                      :error-messages="errors.collect('Motivo da Suspensão')"
                      v-validate="mostrarDialogoSuspender ? 'required' : ''"
                      :name="'Motivo da Suspensão'"
                      label="Motivo da Suspensão"
                      placeholder="Digite aqui o motivo"
                      rows="3"
                      maxlength="1000"
                      :counter="1000"
                      class="required-field"/>
        </v-card-text>
        <v-card-actions class="acoes justify-center">
          <v-btn color="#777" flat @click="fechar">
            Fechar
          </v-btn>
          <v-btn class="botao-primario" flat @click="suspenderLicitacao">
            Suspender
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list-tile>
</template>

<script>
import {mapActions, mapState} from "vuex";
import {actionTypes} from "@/commons/constants";

export default {
  name: 'LicitacaoAtualizacaoAcoesSuspender',
  data() {
    return {
      mostrarDialogoSuspender: false,
      motivoSuspensao: null
    }
  },
  computed: {
    ...mapState(['licitacao'])
  },
  methods: {
    ...mapActions([actionTypes.BUSCAR_LICITACAO]),

    fechar() {
      this.mostrarDialogoSuspender = false
      this.motivoSuspensao = null
    },

    async suspenderLicitacao() {
      await this.validarCampos()

      await this.$store.dispatch(actionTypes.SUSPENDER_LICITACAO, {
        licitacaoId: this.licitacao.id,
        motivoSuspensao: this.motivoSuspensao
      })

      this.mostrarNotificacaoSucessoDefault()
      this.fechar()
      await this.buscarLicitacao(this.licitacao.id)
    },

    async validarCampos(){
      const estaValidado = await this.$validator.validateAll()
      if(!estaValidado){
        throw new Error('Preencha todos os campos obrigatórios.')
      }
    }
  }
}
</script>

<style scoped lang="stylus">
.modal-title
  justify-content space-between

  .v-btn
    padding 0
    margin 0
    color #fff
    box-sizing border-box
    min-width 25px

.botao-primario
  padding 0 25px
  border 1px solid #7aa329
  background-color #7aa329 !important
  color #fff !important
  box-sizing border-box
  margin-left 15px !important

.acoes
  padding 20px 0 !important
</style>